import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import { useTranslation } from 'react-i18next';
import type { DirectDealsListFilters } from '../../types';

export const DirectDealsTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<DirectDealsListFilters>();

  return (
    <TopBar
      filters={criteria.filters as DirectDealsListFilters}
      onChange={onFiltersChange}
      searchText={t('Search Name')}
      useFiltersV2
    />
  );
};
